import React, { Component,useState } from "react";
import * as Constant from  '../../global/const';
import { formatMoneda, parseMonto } from '../../Helpers/formatMoneda';

export default class Print extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      orden: this.props.orden,
      obsequios: this.props.obsequios,
      ref: this.props.ref,
      imagenLogo: (Constant.URL_BASE_IMAGES+'web/resources/logo.png')
    };
  }

  componentWillMount() {}

  render() {
    const { orden, obsequios, ref, imagenLogo } = this.state;
    const pedido = orden.pedido;
    
    const getImpuestos = () =>{
      return ( parseMonto(pedido.iva)
        + parseMonto(pedido.ico)
        + parseMonto(pedido.ibua)
        + parseMonto(pedido.icui)
        + parseMonto(pedido.icl)
        + parseMonto(pedido.adv));
    }
    
    return (
      <div className="conteinerPdf" style={{ width: "100%" }} ref={ref}>
        <div className="HederPdf">
          <img src={imagenLogo} alt="" />
        </div>
        <div className="ContentPdf">
          <div className="HeadPdf">
            <div className="leftHead">
              <span className="texto2Pdf">{pedido.razonSocial}</span>
              <span className="textoPdf">
                Fecha de entrega:{" "}
                <span className="textoPdf">
                  {pedido.fechaEntrega.replace("T", " ").slice(0, 10)}{" "}
                </span>
              </span>
              <span className="textoPdf">
                Dirección de entrega: {pedido.direccion}
              </span>
              <span className="textoPdf">Ciudad: {pedido.ciudad}</span>
            </div>
            <div className="rigthHead">
              <span className="textoPdf">Total de producto(s) {
                  pedido.totalCantidadProductos + pedido.totalCantidadObsequios
                } </span>
              <span className="textoPdf">
                Subtotal
                {" $" + formatMoneda(parseMonto(pedido.precio) - getImpuestos())}
              </span>
              <span className="textoPdf">
                Descuento otorgado
                {" $" + formatMoneda(pedido.valorDesc)}
              </span>
              <span className="textoPdf">
                Impuestos
                {" $" + formatMoneda(getImpuestos())}
              </span>
              <span className="textoPdf">
                Valor total pagado
                {" $" + formatMoneda(pedido.precio)}
              </span>
            </div>
          </div>
          <div className="BodyPdf">
            <div className="HeadBodyPdf">
              <span className="texto2Pdf">Referencia de producto</span>
              <span className="texto2Pdf" id="center_text">Cajas</span>
              <span className="texto2Pdf" id="center_text">Unidades</span>
              <span className="texto2Pdf" id="center_text">Subtotal</span>
            </div>
            <div className="contentBodyPdf">
              {orden.pedido.productos.map((producto, i) =>(
                  <div className="RowPdf" key={i}>
                  <span className="textoPdf"> {producto.producto}</span>
                  <span className="textoPdf" id="center_text">{producto.cantidad}</span>
                  <span className="textoPdf" id="center_text">{producto.cantidadUnidadDigitada}</span>
                  <span className="textoPdf" id="center_text">
                    {" $" +
                      new Intl.NumberFormat("de-DE", {
                        numberingSystem: "latn",
                        style: "decimal",
                        currency: "COP",
                      }).format(producto.total)
                    }
                  </span>

                </div>
                ))
              }
              { 
                obsequios.map((producto, i) => {
                    return (
                    <div className="RowPdf" key={i}>
                      <span className="textoPdf">{producto.producto} </span>
                      <span className="textoPdf" id="center_text">{producto.cantidad}</span>
                      <span className="textoPdf" id="center_text">{producto.cantidadUnidadDigitada}</span>
                      <span className="textoPdf" id="center_text">
                        {" $" +
                          new Intl.NumberFormat("de-DE", {
                            numberingSystem: "latn",
                            style: "decimal",
                            currency: "COP",
                          }).format(producto.total)
                        }
                      </span>
                    </div>
                    )
                })
              }

           </div>
          </div>
          {pedido.tipoPagoPorOrden && pedido.tipoPagoPorOrden.length > 0 && (
            <div className="BodyPdf">
              <span className="subtituloPdf">Método de pago</span>
              <div className="HeadBodyPdfPago">
                <span className="texto2Pdf">Orden</span>
                <span className="texto2Pdf" id="center_text">Sector</span>
                <span className="texto2Pdf" id="center_text">Tipo de pago</span>
              </div>
              <div className="contentBodyPdf">
                {pedido.tipoPagoPorOrden.map((item, i) => (
                  <div className="RowPdfPago" key={i}>
                    <span className="textoPdf">{item.numOrden}</span>
                    <span className="textoPdf" id="center_text">
                      {item.tipoCompania}
                    </span>
                    <span className="textoPdf" id="center_text">
                      {item.tipoPago}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* {obsequios.length > 0 || obsequios != null ? (<div className="BodyPdf">
            <div className="HeadBodyPdf">
              <span className="texto2Pdf">Referencia de obsequios</span>
              <span className="texto2Pdf">Cantidad</span>

            </div>
            <div className="contentBodyPdf">
              {obsequios.map((obsequio, i) => (
                <div className="RowPdf" key={i}>
                  <span className="textoPdf">
                    {obsequio.detallePromocion.length > 0 ? obsequio.detallePromocion[0].producto : null}
                  </span>
                  <span className="textoPdf">{obsequio.detallePromocion.length > 0 ? obsequio.detallePromocion[0].cantidad : null}</span>

                </div>
              ))}
            </div>
          </div>) : null} */}
          <div className="FooterPdf">
            <div className="contentFooterPdf">
              <div className="leftFooterPdf">
                <span>Gracias por tu Pedido</span>
                <span>
                  Para solicitudes, quejas o reclamos por favor consulta
                  cualquiera de estos canales de contacto
                </span>
                <span>www.pedidospostobon.com/negocios</span>
              </div>
              <div className="rigthFooterPdf">
                <div>
                  <span>PBX</span>
                  <span>+57 584 45 65</span>
                </div>
                <div>
                  <span>Email</span>
                  <span>compras.negocios@postobon.com</span>
                </div>
                <div>
                  <span>Whatsapp</span>
                  <span>+57 584 45 65</span>
                </div>
              </div>
            </div>
            <div className="redes">
              <div>
                <div className="icon-red">
                  <i className="fab fa-twitter"></i>
                </div>
                <div className="icon-red">
                  <i className="fab fa-facebook-f"></i>
                </div>
                <div className="icon-red">
                  <i className="fab fa-instagram"></i>
                </div>
                <div className="icon-red">
                  <i className="fab fa-youtube"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
